function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIconYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FFFAF0",
    style: {
      fill: "#FFFAF0",
      fill: "color(display-p3 1.0000 0.9790 0.9400)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.875C17.9975 9.875 16.0399 10.4688 14.3749 11.5814C12.7098 12.6939 11.4121 14.2752 10.6457 16.1253C9.87939 17.9754 9.67888 20.0112 10.0696 21.9753C10.4602 23.9393 11.4245 25.7435 12.8405 27.1595C14.2566 28.5755 16.0607 29.5398 18.0247 29.9305C19.9888 30.3211 22.0246 30.1206 23.8747 29.3543C25.7248 28.5879 27.3061 27.2902 28.4186 25.6251C29.5312 23.9601 30.125 22.0025 30.125 20C30.122 17.3156 29.0543 14.742 27.1562 12.8438C25.258 10.9457 22.6844 9.87798 20 9.875ZM20 27.875C18.4425 27.875 16.9199 27.4131 15.6249 26.5478C14.3299 25.6825 13.3205 24.4526 12.7245 23.0136C12.1284 21.5747 11.9725 19.9913 12.2763 18.4637C12.5802 16.9361 13.3302 15.5329 14.4315 14.4315C15.5329 13.3302 16.9361 12.5802 18.4637 12.2763C19.9913 11.9725 21.5747 12.1284 23.0136 12.7244C24.4526 13.3205 25.6825 14.3298 26.5478 15.6249C27.4131 16.9199 27.875 18.4425 27.875 20C27.8728 22.0879 27.0424 24.0896 25.566 25.566C24.0896 27.0424 22.0879 27.8728 20 27.875ZM18.875 17V23C18.875 23.2984 18.7565 23.5845 18.5455 23.7955C18.3345 24.0065 18.0484 24.125 17.75 24.125C17.4516 24.125 17.1655 24.0065 16.9545 23.7955C16.7435 23.5845 16.625 23.2984 16.625 23V17C16.625 16.7016 16.7435 16.4155 16.9545 16.2045C17.1655 15.9935 17.4516 15.875 17.75 15.875C18.0484 15.875 18.3345 15.9935 18.5455 16.2045C18.7565 16.4155 18.875 16.7016 18.875 17ZM23.375 17V23C23.375 23.2984 23.2565 23.5845 23.0455 23.7955C22.8345 24.0065 22.5484 24.125 22.25 24.125C21.9516 24.125 21.6655 24.0065 21.4545 23.7955C21.2435 23.5845 21.125 23.2984 21.125 23V17C21.125 16.7016 21.2435 16.4155 21.4545 16.2045C21.6655 15.9935 21.9516 15.875 22.25 15.875C22.5484 15.875 22.8345 15.9935 23.0455 16.2045C23.2565 16.4155 23.375 16.7016 23.375 17Z",
    fill: "#D3931C",
    style: {
      fill: "#D3931C",
      fill: "color(display-p3 0.8275 0.5765 0.1098)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIconYellow);
export default __webpack_public_path__ + "static/media/pause-icon-yellow.f7585a0aadd357ca392b3e4d473bfa24.svg";
export { ForwardRef as ReactComponent };